import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

// OBTENER TIPO PRODUCTOS ACTIVOS
export const ObtenerTipoProductosAct = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/TipoProducto/TipoProductosAct`, "GET");
  return respuesta;
};


// OBTENER TODOS LOS TI[O PRODUCTOS
export const ObtenerTipoProductos = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/TipoProducto`, "GET");
  return respuesta;
};

// AGREGAR CURRENCY
export const addTipoProducto = async (data) => {
  const respuesta = await PrivateInterceptor(
    `Base/Global/TipoProducto/add`,
    "POST",
    data
  );
  return respuesta;
};


